<template>
    <div id="layoutSidenav_nav">
        <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
            <div class="sb-sidenav-menu">

                <div class="nav">
                    <template v-if="role == 2">
                        <router-link :to="{ name: 'host.dashboard.index' }" class="nav-link mb-1"
                            :class="{ active: $route.name === 'host.dashboard.index' }">
                            <div class="sb-nav-link-icon"><i class="fa-solid fa-table-cells-large"></i></div> Dashboard
                        </router-link>
                        <router-link :to="{ name: 'host.event.index' }" class="nav-link mb-1"
                            :class="{ active: $route.name === 'host.event.index' }">
                            <div class="sb-nav-link-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                                    fill="none">
                                    <g clip-path="url(#clip0_1707_4608)">
                                        <path
                                            d="M12.9998 16.0478C12.8666 16.0479 12.7364 16.0081 12.626 15.9334C12.5156 15.8588 12.4301 15.7528 12.3805 15.6291L11.8178 14.2204L10.4072 13.6264C10.2862 13.573 10.1836 13.485 10.1125 13.3735C10.0413 13.262 10.0047 13.1319 10.0072 12.9997C10.0097 12.8674 10.0512 12.7389 10.1265 12.6301C10.2018 12.5214 10.3076 12.4373 10.4305 12.3884L11.8225 11.8611L12.3805 10.4664C12.4318 10.3446 12.518 10.2405 12.6281 10.1674C12.7383 10.0943 12.8676 10.0552 12.9998 10.0552C13.1321 10.0552 13.2614 10.0943 13.3715 10.1674C13.4817 10.2405 13.5678 10.3446 13.6192 10.4664L14.1798 11.8664L15.5798 12.4271C15.702 12.4782 15.8063 12.5642 15.8796 12.6744C15.953 12.7846 15.9921 12.9141 15.9921 13.0464C15.9921 13.1788 15.953 13.3083 15.8796 13.4184C15.8063 13.5286 15.702 13.6147 15.5798 13.6658L14.1798 14.2264L13.6192 15.6264C13.57 15.7506 13.4847 15.8572 13.3743 15.9323C13.2638 16.0074 13.1334 16.0477 12.9998 16.0478ZM6.6665 14.0478C6.37848 14.0512 6.09708 13.9613 5.86442 13.7915C5.63176 13.6217 5.46035 13.3811 5.37583 13.1058L4.29983 9.74111L0.924496 8.61178C0.652071 8.52072 0.415641 8.34543 0.249354 8.11122C0.0830676 7.87701 -0.00446835 7.596 -0.000610147 7.30879C0.00324806 7.02157 0.0983007 6.74302 0.270819 6.51336C0.443337 6.2837 0.68439 6.11482 0.959163 6.03112L4.30783 5.00845L5.43583 1.63911C5.5197 1.36236 5.69318 1.12134 5.92899 0.953953C6.16481 0.786567 6.44957 0.702315 6.73849 0.714448C7.02656 0.714838 7.30675 0.808512 7.53713 0.981448C7.76752 1.15438 7.93569 1.39728 8.01649 1.67378L9.03783 5.01711L12.3912 6.09045C12.6616 6.18117 12.8968 6.35457 13.0634 6.58616C13.23 6.81775 13.3196 7.09583 13.3196 7.38111C13.3196 7.6664 13.23 7.94448 13.0634 8.17607C12.8968 8.40766 12.6616 8.58106 12.3912 8.67178L9.03183 9.74645L7.95716 13.1058C7.87264 13.3811 7.70123 13.6217 7.46857 13.7915C7.23591 13.9613 6.95451 14.0512 6.6665 14.0478ZM13.6665 4.71445C13.5179 4.71444 13.3735 4.66478 13.2564 4.57334C13.1392 4.48191 13.0559 4.35395 13.0198 4.20978L12.7818 3.25645L11.8265 2.99978C11.6829 2.9612 11.5563 2.87573 11.4669 2.75696C11.3775 2.63818 11.3303 2.49292 11.3329 2.34427C11.3355 2.19561 11.3877 2.05209 11.4813 1.93652C11.5748 1.82095 11.7043 1.73997 11.8492 1.70645L12.7825 1.48978L13.0198 0.552448C13.056 0.408297 13.1392 0.280349 13.2564 0.188928C13.3735 0.0975057 13.5179 0.0478516 13.6665 0.0478516C13.8151 0.0478516 13.9595 0.0975057 14.0766 0.188928C14.1938 0.280349 14.277 0.408297 14.3132 0.552448L14.5492 1.49778L15.4945 1.73445C15.6386 1.77058 15.7666 1.85383 15.858 1.97099C15.9494 2.08816 15.9991 2.23251 15.9991 2.38111C15.9991 2.52972 15.9494 2.67407 15.858 2.79124C15.7666 2.9084 15.6386 2.99165 15.4945 3.02778L14.5492 3.26445L14.3132 4.20978C14.277 4.35395 14.1938 4.48191 14.0766 4.57334C13.9595 4.66478 13.8151 4.71444 13.6665 4.71445Z"
                                            fill="#FCFCFC" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1707_4608">
                                            <rect width="16" height="16" fill="white"
                                                transform="translate(0 0.0478516)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div> My Events
                        </router-link>
                        <router-link :to="{ name: 'host.profile.index' }" class="nav-link mb-1"
                            :class="{ active: $route.name === 'host.profile.index' }">
                            <div class="sb-nav-link-icon">
                                <i class="fa-regular fa-circle-user"></i>
                            </div> Profile
                        </router-link>
                    </template>
                    <template v-else-if="role == 3">
                        <router-link :to="{ name: 'attendee.dashboard.index' }" class="nav-link mb-1"
                            :class="{ active: $route.name === 'attendee.dashboard.index' }">
                            <div class="sb-nav-link-icon"><i class="fa-solid fa-table-cells-large"></i></div> Dashboard
                        </router-link>
                        <router-link :to="{ name: 'attendee.profile.index' }" class="nav-link mb-1"
                            :class="{ active: $route.name === 'attendee.profile.index' }">
                            <div class="sb-nav-link-icon">
                                <i class="fa-regular fa-circle-user"></i>
                            </div> Profile
                        </router-link>
                    </template>
                    <template v-else-if="role == 4">
                        <button @click="showLoginAlert" class="nav-link mb-1"
                            :class="{ active: $route.name === 'attendee.dashboard.index' }">
                            <div class="sb-nav-link-icon"><i class="fa-solid fa-table-cells-large"></i></div> Dashboard
                        </button>
                        <button @click="showLoginAlert" class="nav-link mb-1"
                            :class="{ active: $route.name === 'attendee.profile.index' }">
                            <div class="sb-nav-link-icon">
                                <i class="fa-regular fa-circle-user"></i>
                            </div> Profile
                        </button>
                    </template>
                </div>
            </div>
        </nav>
    </div>
    <LoginAlert ref="loginAlert" />
</template>
<script>
import store from '@/store';
import { computed, ref, watch } from 'vue';
import LoginAlert from '@/components/Shared/LoginAlert.vue';

export default ({
    components: {
        LoginAlert
  },
    setup() {
        const loginAlert = ref(null);
        const role = computed(() => {
            return store.getters['user/getUserRole'];
        });

        watch(
            () => store.getters['user/getUserRole'],
            () => {
                role.value = store.getters['user/getUserRole'];
            }
        );

        const showLoginAlert = () => {
            loginAlert.value.loginAlert();
        }

        return {
            role,
            loginAlert,
            showLoginAlert
        }
    }
})
</script>
